import { Component, Inject, OnInit } from '@angular/core';
import { DwMdSectionConfigBaseComponent2, DwComponentSectionConfigPreference, DwMdItem, DwQueryHelper, DevwareMetaDataService, DwOrmDataService, DwOrmDataServiceToken, DwExpressionService, DwMessagingService, DwMetaDataService, DwMetaDataServiceToken, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwMetadataFormUtilService, DwMetadataFormBuilderService, DwContextService, DwMetaDataFormService } from '@devwareapps/devware-cap';
import { NoteControlNewConfig } from '../../models/note-control-new-config.model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
import { NotesMetaDataLookups, NotesMetaDataService } from '../../../meta-data/notes-meta-data.service';

@Component({
  selector: 'app-note-control-new-config',
  templateUrl: './note-control-new-config.component.html',
  styleUrls: ['./note-control-new-config.component.scss']
})
export class NoteControlNewConfigComponent
  extends DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<NoteControlNewConfig>>  {

  constructor(
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    dwExpressionService: DwExpressionService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private notesMetaDataService: NotesMetaDataService,
    dwFormUtilService: DwMetadataFormUtilService,
    dwFormBuilderService: DwMetadataFormBuilderService,
    dwFormService: DwMetaDataFormService,
    dwContextService: DwContextService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    fb: FormBuilder
  ) {
    super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
  }
  configFormGroup: FormGroup;
  itemMetaData: DwMdItem;
  tableMetaData: any;
  lookupId = NotesMetaDataLookups.NoteTypeAllItems;

  setupForm() {
    // Add config fields to the form

    this.configFormGroup = new FormGroup({
      NoteKey: new FormControl(),
      CanDeletePermissionMeaning: new FormControl(),
      CanEditPermissionMeaning: new FormControl(),
      NoteType: new FormControl(),
      FilterListOnType: new FormControl(),
      HideAutoDelete: new FormControl(),
      ReadOnlyKey: new FormControl(),
      ShowNoteSource: new FormControl(),
      HeightInRows: new FormControl(),
      ExcludeNoteTypes: new FormControl(),
      SaveRecordId: new FormControl()
    });

    this.formGroup.addControl('config', this.configFormGroup);

  }

  setConfigValue(value) {
    // temp fix
  }
}
